module.exports = __webpack_public_path__ + "media/CN_007.9b53867b.mp3";